var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 15.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,.2A8,8,0,0,0,5.47,15.79c.4.07.55-.18.55-.39S6,14.71,6,14C3.78,14.53,3.31,13,3.31,13a2.12,2.12,0,0,0-.89-1.17c-.72-.5.06-.49.06-.49a1.68,1.68,0,0,1,1.22.83A1.7,1.7,0,0,0,6,12.8a1.71,1.71,0,0,1,.51-1.07c-1.78-.2-3.64-.89-3.64-3.95a3.11,3.11,0,0,1,.82-2.15A2.85,2.85,0,0,1,3.8,3.52s.67-.22,2.2.82a7.54,7.54,0,0,1,4,0c1.53-1,2.2-.82,2.2-.82a2.85,2.85,0,0,1,.08,2.11,3.11,3.11,0,0,1,.82,2.15c0,3.07-1.87,3.75-3.65,4A1.88,1.88,0,0,1,10,13.21c0,1.07,0,1.93,0,2.19s.15.47.55.39A8,8,0,0,0,8,.2Z",
    transform: "translate(0 -0.2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon2);
export default __webpack_public_path__ + "static/media/nav-icon2.84c7985bd0fe1d12b27128e76848fc1c.svg";
export { ForwardRef as ReactComponent };